module.exports = __webpack_public_path__ + "img/help-icon-dark.07a05595.svg";